






















































import { Component, mixins } from '@niknevis/vue-modules'
import AdminLayout from '@/modules/common/layout/components/admin/AdminLayout.vue'
import TesTable from '@/modules/common/tes-table/components/shared/TesTable.vue'
import { Prop, ProvideReactive } from 'vue-property-decorator'
import { QsPaginatableMixin } from '@/modules/shared/mixins/qs-paginatable.mixin'
import { QsSearchableMixin } from '@/modules/shared/mixins/qs-searchable.mixin'
import PaginationWithInput from '@/modules/shared/components/shared/pagination/PaginationWithInput.vue'
import FilterRow from '@/modules/common/filter/components/shared/layout/FilterRow.vue'
import AdminInvoiceCreateButton from '@/modules/invoice/components/admin/AdminInvoiceCreateButton.vue'
import { getFaqColumnsInAdmin } from '@/modules/faq/models/columns/faq.column'
import AdminFaqTableRow from '@/modules/faq/components/admin/table/AdminFaqTableRow.vue'
import { FaqCollectionModel, FaqCollectionType } from '@/modules/faq/models/faq-collection.model'
import { FaqCreateUseCase } from '@/modules/faq/use-cases/admin/faq-create.use-case'
import AdminFaqForm from '@/modules/faq/components/admin/AdminFaqForm.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { FaqType } from '@/modules/faq/models/faq-resource.model'

@Component({
  layout: AdminLayout,
  layoutProps: {
    page_header: 'لیست سوالات متداول'
  },
  metaInfo: {
    title: 'لیست سوالات متداول'
  },
  components: {
    BaseButton,
    AdminFaqForm,
    AdminInvoiceCreateButton,
    TesTable,
    FilterRow,
    PaginationWithInput
  }
})
export default class IndexPage extends mixins(QsPaginatableMixin, QsSearchableMixin) {
  constructor(
    private readonly useCase: FaqCreateUseCase
  ) {
    super()
  }

  @ProvideReactive()
  @Prop() faqs: FaqCollectionType
  private rowComponent = AdminFaqTableRow
  private columns = getFaqColumnsInAdmin()
  private needClearForm: boolean = false
  private createBtnLabel = 'ثبت اطلاعات'
  private faq: FaqCollectionModel = this.emptyAnswer()


  private filters = []

  onSubmit() {
    this.useCase.execute(this.faq).then(() => {
      if (this.useCase.isSuccess) this.faq = this.emptyAnswer()
    })
  }

  emptyAnswer(): FaqCollectionModel {
    return {
      answer: '',
      created_at: '',
      id: 0,
      question: '',
      type: FaqType.PANEL,
      updated_at: ''
    }
  }

  protected get model(): any {
    return this.faqs
  }

  private updatePage(page: number) {
    this.updateTable({
      pagination: {
        ...this.pagination,
        page
      }
    })
  }

}
